export const iconFontAwesomeChartsDiagramsChartArea = (
	<i className="fa-solid fa-chart-area"></i>
);
